"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    locationMetadataLinkClickHandler: ()=>locationMetadataLinkClickHandler
});
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const index_js_namespaceObject = require("../../constants/index.js");
const useSetHotelPinOnMapHook_js_namespaceObject = require("../../HotelComponent/useSetHotelPinOnMapHook.js");
const googleMapManager_js_namespaceObject = require("../Maps/googleMapManager.js");
const external_MetadataManager_js_namespaceObject = require("./MetadataManager.js");
const locationMetadataLinkClickHandler = (options)=>{
    const { pinsInCurrentLine, targetPin, setIsMapOpened } = options;
    const hotelOnMapList = external_MetadataManager_js_namespaceObject.inlineMetadataManager.getHotelOnMapList();
    if (targetPin?.type === index_js_namespaceObject.mapPinType.HOTEL && targetPin?.hotelId) {
        const hotelPin = hotelOnMapList?.find((p)=>{
            const hotel = p?.hotel;
            if (hotel?.hotelType !== 'SOPQ') return String(p?.hotel?.hotelId) === String(targetPin.hotelId);
            {
                const expressId = (0, useSetHotelPinOnMapHook_js_namespaceObject.expressDealHotelId)(hotel);
                return expressId === targetPin.hotelId;
            }
        });
        const hotelId = hotelPin?.hotelId || targetPin.hotelId;
        const hotelDetailURL = hotelPin?.hotelDetailURL || `https://www.priceline.com/relax/at/${targetPin.hotelId}`;
        analytics_js_default().log({
            label: 'HotelSearchResult',
            hotelId: hotelId,
            message: 'HOTEL_DETAIL_LINK_CLICKED',
            clickedOnPennMessage: 'Y'
        });
        window.open(hotelDetailURL, '_blank');
    } else {
        setIsMapOpened(true);
        googleMapManager_js_namespaceObject.mapManager.addCallback(()=>{
            googleMapManager_js_namespaceObject.mapManager.fitBoundsOnCurrentMap(pinsInCurrentLine).catch((e)=>{
                analytics_js_default().logError({
                    loggedFrom: 'locationMetadataLinkClickHandler:fitBoundsOnCurrentMap',
                    message: 'Failed to call fitBounds on map',
                    error: e.message
                });
            });
        });
    }
};
exports.locationMetadataLinkClickHandler = __webpack_exports__.locationMetadataLinkClickHandler;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "locationMetadataLinkClickHandler"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
